export const DIRECTOR_RIGHTS = {
    ANALYTIC: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    REPORTS: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    RENT: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    CLIENT: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    INVENTORY: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    CALENDAR: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    EXPENSE: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    STOCK: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    REPAIR: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    EMPLOYEE: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    SETTINGS: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    LOG_JOURNAL: {
        canRead: true,
        canAdd: true,
        canEdit: true,
        canDelete: true,
        canRight: true,
        canExport: true,
        canReopen: true,
    },
    hasAccessToPoints: true,
};
